import api from 'services/api.service';

export const createSubscriptionCheckoutSession = (redirectUrl, priceId, promoteKitReferral) => api
  .post('/companies/subscription-checkout-session', { redirectUrl, priceId, promoteKitReferral });

export const createSetupCheckoutSession = (redirectUrl) => api
  .post('/companies/setup-checkout-session', { redirectUrl });

export const createUpdateSubscriptionSession = (redirectUrl, priceId) => api
  .post('companies/update-subscription-session', { redirectUrl, priceId });

export const getSubscription = () => api.get('/companies/subscription');

export const getPaymentMethod = () => api
  .get('/companies/payment-method');

export const cancelSubscription = (reasons) => api
  .delete('/companies/subscription', { reasons });

export const resumeSubscription = () => api
  .post('/companies/subscription/resume');

export const actualizeSubscriptionQty = () => api
  .post('/companies/actualize-subscription-qty');

export const getAdvancedFields = () => api
  .get(`/companies/advanced-fields`);

export const getInvoices = () => api
  .get('/companies/invoices');

export const getPublicProfile = (companyId) => api
  .get(`/companies/${companyId}/public-profile`);
